<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="pxWidth" :height="pxWidth" version="1.1">
    <path :d="`M1 0 V ${pxWidth-1} H ${pxWidth-1} L1 0`" fill="white"/>
    <line x1="1" x2="1" y1="0" :y2="pxWidth" :stroke="color" stroke-width="2"
      stroke-dasharray="4"/>
    <line x1="0" :x2="pxWidth" :y1="pxWidth-1" :y2="pxWidth-1" :stroke="color" stroke-width="2"
      stroke-dasharray="4" />
    <line :x1="pxWidth" x2="0" :y1="pxWidth" y2="0" :stroke="color" stroke-width="2" />
  </svg>
</template>

<script>
import PieceMixin from './PieceMixin';

export default {
  mixins: [PieceMixin],
};
</script>
